import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!mobileOpen) return;
      
      if (e.key === 'Escape') {
        setMobileOpen(false);
        return;
      }
      
      if (e.key === 'Tab' && menuRef.current) {
        const focusableElements = menuRef.current.querySelectorAll('a, button');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        
        if (e.shiftKey && document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        } else if (!e.shiftKey && document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [mobileOpen]);

  const navLinks = [
    { path: '/', label: 'Products' },
    { path: '/labs', label: 'Labs' },
    { path: '/contact', label: 'Contact' },
  ];

  const handleToggleClick = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <nav 
        className={`navbar ${scrolled ? 'scrolled' : ''}`} 
        role="navigation"
        aria-label="Main navigation"
      >
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" aria-label="BACIMO - Home">
            <img 
              src="/logo_trans_name.png" 
              alt="" 
              className="logo-image"
              aria-hidden="true"
            />
            <span className="visually-hidden">BACIMO</span>
          </Link>

          <div 
            id="navbar-links"
            ref={menuRef}
            className={`navbar-links ${mobileOpen ? 'open' : ''}`}
            aria-label="Primary"
          >
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`navbar-link ${location.pathname === link.path ? 'active' : ''}`}
                aria-current={location.pathname === link.path ? 'page' : undefined}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            className="navbar-toggle"
            onClick={handleToggleClick}
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileOpen}
            aria-controls="navbar-links"
          >
            <span 
              className={`hamburger ${mobileOpen ? 'open' : ''}`} 
              aria-hidden="true"
            ></span>
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
